import { defineComponent, ref, computed } from 'vue-demi';
import { OrButtonV3, OrIconV3 } from '@onereach/ui-components';
import { resolveComponent, openBlock, createBlock, normalizeClass, withCtx, renderSlot, createVNode } from 'vue';

var script = defineComponent({
  name: 'ServiceNavigationButton',
  components: {
    OrButtonV3,
    OrIconV3
  },
  props: {
    active: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['click'],
  expose: ['root'],
  setup() {
    const button = ref();
    const root = computed(() => {
      var _a;
      return (_a = button === null || button === void 0 ? void 0 : button.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    return {
      button,
      root
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconV3 = resolveComponent("OrIconV3");
  const _component_OrButtonV3 = resolveComponent("OrButtonV3");
  return openBlock(), createBlock(_component_OrButtonV3, {
    ref: "button",
    size: "small",
    color: "inherit",
    type: "button",
    class: normalizeClass(["!min-w-0 !gap-xs bg-black !p-xs text-white !shadow-none hover:bg-inverse-surface", {
      '!bg-white !text-black': _ctx.active
    }]),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "default"), createVNode(_component_OrIconV3, {
      icon: _ctx.active ? 'expand_less' : 'expand_more',
      color: "inherit"
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationButton/ServiceNavigationButton.vue";

export { script as s };
